module.exports = __webpack_public_path__ + "img/app-calendar.424d48a9.png";